<script>
  import {onMount} from 'svelte';
  import * as d3 from 'd3';
  import {httpClient} from '@/utils/http-client';

  let data = {};

  async function fetchData() {
    // const response = await fetch("http://localhost:3000/analytics/average-thumbnails-per-user-per-day"); // Adjust the URL
    const response = await httpClient.get('/user-stats/imagestats/1');
    console.log(response);
    data = response.data;
    console.log(data);
    if (data.count) {
      data.count = data.count.filter(d => d.type === 'thumbnail' || d.type === 'quote');
    }
    drawChart(data.result);
  }

  let tooltip;

  onMount(() => {
    tooltip = d3
      .select('body')
      .append('div')
      .attr('class', 'tooltip')
      .style('position', 'absolute')
      .style('visibility', 'hidden')
      .style('padding', '8px')
      .style('background-color', 'rgba(0,0,0,0.7)')
      .style('border-radius', '4px')
      .style('color', '#fff');

    fetchData();
  });

  function drawChart(data) {
    const margin = {top: 40, right: 20, bottom: 30, left: 50};
    const width = 800 - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    const svg = d3
      .select('#chart')
      .append('svg')
      .attr('width', width + margin.left + margin.right + 100)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    const dates = Object.keys(data);
    const types = ['thumbnail', 'quote'];

    const stackedData = d3.stack().keys(types)(
      dates.map(date => {
        const record = data[date];
        return {date, ...record};
      })
    );

    const x = d3.scaleBand().domain(dates).range([0, width]).padding(0.1);

    const y = d3
      .scaleLinear()
      .domain([0, d3.max(stackedData, d => d3.max(d, d => d[1]))])
      .nice()
      .range([height, 0]);

    const color = d3.scaleOrdinal(d3.schemeCategory10).domain(types);

    svg
      .append('g')
      .attr('transform', `translate(0, ${height})`)
      .call(
        d3
          .axisBottom(x)
          .tickFormat(d => d)
          .tickSize(0)
      )
      .selectAll('text')
      .attr('transform', 'rotate(-45)')
      .style('text-anchor', 'end');

    svg.append('g').call(d3.axisLeft(y));

    svg
      .append('g')
      .selectAll('g')
      .data(stackedData)
      .enter()
      .append('g')
      .attr('fill', d => color(d.key))
      .selectAll('rect')
      .data(d => d)
      .enter()
      .append('rect')
      .attr('x', d => x(d.data.date))
      .attr('y', height) // Start at the bottom for animation
      .attr('height', 0) // Start with height 0 for animation
      .attr('width', x.bandwidth())
      .transition()
      .duration(800)
      .attr('y', d => y(d[1]))
      .attr('height', d => y(d[0]) - y(d[1]));

    // Add hover interactivity
    svg
      .selectAll('rect')
      .on('mouseover', function (event, d) {
        d3.select(this).attr('opacity', 0.8);
        tooltip.style('visibility', 'visible').html(`
					<strong>Date:</strong> ${d.data.date}<br>
					<strong>Type:</strong> ${d3.select(this.parentNode).datum().key}<br>
					<strong>Count:</strong> ${(d[1] - d[0]).toFixed(2)}
				`);
      })
      .on('mousemove', function (event) {
        tooltip.style('top', event.pageY - 20 + 'px').style('left', event.pageX + 10 + 'px');
      })
      .on('mouseout', function () {
        d3.select(this).attr('opacity', 1);
        tooltip.style('visibility', 'hidden');
      });

    // Legend
    const legend = svg.append('g').attr('transform', `translate(${width + 20}, 0)`);

    legend
      .selectAll('.legend-item')
      .data(types)
      .enter()
      .append('rect')
      .attr('x', 0)
      .attr('y', (d, i) => i * 20)
      .attr('width', 10)
      .attr('height', 10)
      .attr('fill', d => color(d));

    legend
      .selectAll('.legend-label')
      .data(types)
      .enter()
      .append('text')
      .attr('x', 15)
      .attr('y', (d, i) => i * 20 + 9)
      .text(d => d)
      .attr('text-anchor', 'start')
      .style('alignment-baseline', 'middle');
  }
</script>

<div class="flex flex-col items-center">
  <h1 class="py-4 text-2xl font-bold">Sermon Images Analytics</h1>
  <div class="flex flex-row gap-2 p-4">
    {#if data.count}
      {#each data.count as { type, count }}
        <div class="flex flex-col items-center gap-2 rounded-lg bg-white p-4 shadow-md">
          <h2 class="label mb-2 text-lg font-semibold">Total {type} Images Made</h2>
          <p class="text-3xl font-bold">{count}</p>
        </div>
      {/each}
    {/if}
    <div class="flex flex-col items-center gap-2 rounded-lg bg-white p-4 shadow-md">
      <h2 class="label mb-2 text-lg font-semibold">Sermon Images Users for the past 1 week</h2>
      <p class="text-3xl font-bold">{data.userCount}</p>
    </div>
  </div>
  <h2 class="label mb-2 text-lg font-semibold">Average Sermon Images Made Per User Per Day</h2>
  <div id="chart"></div>
</div>

<style>
  #chart {
    display: flex;
    justify-content: center;
  }
  .label {
    text-transform: capitalize;
  }
</style>
